import { TableConfig } from "../../../../common/tables/config/TableConfig";
import { ShopifyProductForAdmin } from "../../../../../../common/tables/shopify/ShopifyProductForAdmin";
import { SortOrder } from "../../../../../../common/query-filters";
import { CellType } from "../../../../common/tables/config/CellType";

export const DefaultShopifyProductTableConfig: TableConfig<ShopifyProductForAdmin> = {
    columns: [
        {
            columnName: "id",
            displayName: "Shopify ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "140px",
            sortable: false,
            filterable: true,
        },
        {
            columnName: "title",
            displayName: "Title",
            cellType: CellType.readOnlyTextWithMenuButton,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "240px",
            sortable: true,
            filterable: true,
        },
        {
            columnName: "createdAt",
            displayName: "Created At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "updatedAt",
            displayName: "Updated At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "status",
            displayName: "Status",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: true,
        },
        {
            columnName: "variantCount",
            displayName: "Variants",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "100px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "vendor",
            displayName: "Vendor",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: true,
            filterable: true,
        },
        {
            columnName: "storeName",
            displayName: "Store",
            cellType: CellType.singleSelect,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: true,
        },
        {
            columnName: "productListingId",
            displayName: "Product Listing ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "200px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "hasPayoutRuleAssignments",
            displayName: "Payout Rules",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "hasCostMetadata",
            displayName: "Cost Metadata",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "createdAt",
        pageSize: 50,
    },
};
